import React from 'react';
import './AboutSection.css';

const AboutSection: React.FC = () => {
  return (
    <section id="about" className="about-section">
      <div className="about-background" />
      
      <div className="container">
        <div className="about-container">
          
          {/* Section Header */}
          <div className="about-header">
            <div className="about-badge">
              <div className="about-badge-dot" />
              Who We Are
            </div>
            
            <h2 className="about-title">About Nuroveli</h2>
            
            <p className="about-subtitle">
              Leading the Future of Cybersecurity with Advanced AI Technology
            </p>
          </div>
          
          {/* Content Grid */}
          <div className="about-content">
            
            {/* Mission Card */}
            <div className="about-card about-card-primary">
              <div className="about-card-icon">
                <i className="ri-focus-3-line"></i>
              </div>
              <h3 className="about-card-title">Our Mission</h3>
              <p className="about-card-description">
                To revolutionize cybersecurity through cutting-edge AI technology, 
                providing businesses with proactive threat detection and intelligent 
                security insights that stay ahead of evolving cyber threats.
              </p>
            </div>
            
            {/* Vision Card */}
            <div className="about-card about-card-secondary">
              <div className="about-card-icon">
                <i className="ri-rocket-2-line"></i>
              </div>
              <h3 className="about-card-title">Our Vision</h3>
              <p className="about-card-description">
                A world where businesses can operate securely in the digital landscape, 
                protected by intelligent systems that predict, prevent, and respond to 
                cyber threats in real-time.
              </p>
            </div>
            
            {/* Values Card */}
            <div className="about-card about-card-tertiary">
              <div className="about-card-icon">
                <i className="ri-flashlight-line"></i>
              </div>
              <h3 className="about-card-title">Our Values</h3>
              <p className="about-card-description">
                Innovation, reliability, and transparency drive everything we do. 
                We believe in empowering organizations with the tools and knowledge 
                they need to build robust cybersecurity defenses.
              </p>
            </div>
            
          </div>
          
          {/* Stats Section */}
          <div className="about-stats">
            <div className="about-stat">
              <div className="about-stat-number">5+</div>
              <div className="about-stat-label">Years Experience</div>
            </div>
            <div className="about-stat">
              <div className="about-stat-number">500+</div>
              <div className="about-stat-label">Clients Protected</div>
            </div>
            <div className="about-stat">
              <div className="about-stat-number">99.9%</div>
              <div className="about-stat-label">Threat Detection Rate</div>
            </div>
            <div className="about-stat">
              <div className="about-stat-number">24/7</div>
              <div className="about-stat-label">Security Monitoring</div>
            </div>
          </div>
          
          {/* Team Section */}
          <div className="about-team">
            <h3 className="about-team-title">Expert Team</h3>
            <p className="about-team-description">
              Our team consists of cybersecurity experts, AI researchers, and software engineers 
              dedicated to creating the most advanced threat detection platform in the industry.
            </p>
            
            <div className="about-team-grid">
              <div className="about-team-card">
                <div className="about-team-avatar">
                  <i className="ri-code-s-slash-line"></i>
                </div>
                <h4 className="about-team-name">Security Engineers</h4>
                <p className="about-team-role">Threat Analysis & Detection</p>
              </div>
              
              <div className="about-team-card">
                <div className="about-team-avatar">
                  <i className="ri-brain-line"></i>
                </div>
                <h4 className="about-team-name">AI Researchers</h4>
                <p className="about-team-role">Machine Learning & Analytics</p>
              </div>
              
              <div className="about-team-card">
                <div className="about-team-avatar">
                  <i className="ri-shield-user-line"></i>
                </div>
                <h4 className="about-team-name">Cybersecurity Experts</h4>
                <p className="about-team-role">Strategy & Implementation</p>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
